const state = {
    serviceCategories: [],
    slaInfo: {},
    slaList: []
}

const mutations = {
    SET_SERVICE_CATEGORIES(state, payload) {
        state.serviceCategories = payload;
    },
    SET_SLA_INFO(state, payload) {
        state.slaInfo = payload;
    },
    SET_SLA_LIST(state, payload) {
        state.slaList = payload;
    },
    CREATE_SLA(state, payload) {
        state.slaList = [...state.slaList.items, payload];
    }
}

const actions = {
    getServiceCategories({commit}, params){
        return new Promise((resolve, reject) => {
            global.axios.get(`api/contracts/${params.contractId}/tree-service-categories/${params.categoryId}`)
                .then(response => {
                    if (!params.categoryId) {
                        commit( 'SET_SERVICE_CATEGORIES', response.data.data );
                    }
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    /* Sla - Fault Type*/
    getSLAFaultType({commit}, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/sla-priority-fault-type`, {
                params: params
            })
            .then(response => {
                resolve(response.data.data);
            })
            .catch(error => reject(error));
        });
    },
    createSLAFaultType({commit}, params) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/sla-priority-fault-type`, params)
            .then(response => {
                resolve(response.data.data);
            })
            .catch(error => reject(error));
        });
    },
    updateSLAFaultType({commit}, params) {
        return new Promise((resolve, reject) => {
            global.axios.put(`api/sla-priority-fault-type/${params.id}`, params)
            .then(response => {
                resolve(response.data.data);
            })
            .catch(error => reject(error));
        });
    },
    deleteSLAFaultType({commit}, params) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`api/sla-priority-fault-type`, {
                data: {
                    ids: params
                }
            })
            .then(response => {
                resolve(response.data.data);
            })
            .catch(error => reject(error));
        });
    },
    getSlaList({commit}, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/sla`, {
                params: params
            })
                .then(response => {
                    commit('SET_SLA_LIST', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    getSlaInfo({commit}, slaId) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/sla/${slaId}`)
                .then(response => {
                    commit('SET_SLA_INFO', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        })
    },
    createSla({commit}, params) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/sla`, params.sla)
                .then(response => {
                    commit('CREATE_SLA', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        })
    },
    updateSlaInfo({commit}, params) {
        return new Promise((resolve, reject) => {
            global.axios.put(`api/sla/${params.id}`, params)
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        })
    },
    deleteSla({commit}, ids) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`api/sla`, {
                data: {
                    ids: ids
                }
            })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        })
    }
}

const getters = {
    serviceCategories: state => state.serviceCategories,
    slaInfo: state => state.slaInfo,
    slaList: state => state.slaList
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}